/** "€69" / "69 €" (or "€57,50" when not whole) in the visitor's locale. */
export function fmtAmount(amount: number, currency: string, locale: string, opts?: { whole?: boolean }): string {
  const whole = opts?.whole ?? Number.isInteger(amount);
  try {
    return new Intl.NumberFormat(locale === "de" ? "de-DE" : "en-IE", {
      style: "currency",
      currency,
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2,
    }).format(amount);
  } catch {
    return `${amount} ${currency}`;
  }
}

/** A catalog price (minor units) → display string; `fallback` when the amount is missing. */
export function fmtPrice(
  p: { amount: number; currency: string } | null | undefined,
  locale: string,
  fallback: string,
): string {
  if (!p || !Number.isFinite(p.amount)) return fallback;
  return fmtAmount(p.amount / 100, p.currency, locale, { whole: p.amount % 100 === 0 });
}
